import Repository from '@/api/Repository'

const resource = '/user'

export default {
  // csrfCookie() {
  //   return Repository.get('sanctum/csrf-cookie')
  // },
  login(data) {
    return Repository.post(`${resource}/login`, data)
  },
  register(name, email, profileId) {
    return Repository.post(`${resource}/register`, {
      name,
      email,
      profile_id: profileId,
    })
  },
  info() {
    return Repository.get(resource)
  },
  update(data) {
    return Repository.post(resource, data)
  },
  delete(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  getGroup(id, data) {
    let url = `${resource}/group`
    if (id !== null) {
      url += `/${id}`
    }
    return Repository.get(url, data)
  },
  list() {
    return Repository.get(`${resource}/list`)
  },
  forgot(email) {
    return Repository.post('password/forgot', { email })
  },
  reset(email, password, confirmPassword, token) {
    return Repository.post('password/reset', {
      email,
      password,
      password_confirmation: confirmPassword,
      token,
    })
  },
  toggleLock(id) {
    return Repository.post(`${resource}/${id}/lock`)
  },
}
